import { render, staticRenderFns } from "./UploadedPhotos.vue?vue&type=template&id=23de6ac4&scoped=true"
import script from "./UploadedPhotos.vue?vue&type=script&lang=js"
export * from "./UploadedPhotos.vue?vue&type=script&lang=js"
import style0 from "./UploadedPhotos.vue?vue&type=style&index=0&id=23de6ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de6ac4",
  null
  
)

export default component.exports